import { GetCollection, GetCollectionCount, GetUserCollections, IsInCollection } from '~/constants/getters';
import {
  AddToCollection,
  CreateCollection,
  RemoveCollection,
  RemoveFromCollection,
  SetCollection,
  SetCollections,
  SetCollectionThumbs,
  UpdateCollection,
} from '~/constants/actions';
import { COLLECTIONS } from '~/constants/collections';

const defaultState = () => ({
  collections: {
    [COLLECTIONS.favorites]: { documents: [], collectionId: COLLECTIONS.favorites },
  },
});

const state = defaultState;

const getters = {
  [GetCollectionCount]: (state) => (collectionName) => state.collections[collectionName].documents.length,
  [GetCollection]: (state) => (collectionId) => state.collections[collectionId],
  [IsInCollection]: (state) => (collectionName, documentId) => {
    const index = state.collections[collectionName].findIndex((doc) => {
      const id = doc.externalId || doc;
      return id === documentId;
    });
    return index > -1;
  },
  [GetUserCollections]: (state) => Object.values(state.collections),
};

const mutations = {
  [AddToCollection](state, { collectionId, document, thumbUrl }) {
    const documents = state.collections[collectionId].documents;
    state.collections[collectionId] = {
      ...state.collections[collectionId],
      documents: [...documents, document],
      thumbUrl,
    };
  },
  [RemoveFromCollection](state, { collectionId, documentId, thumbUrl }) {
    const documents = state.collections[collectionId].documents.filter((doc) => {
      const id = doc.externalId || doc;
      return id !== documentId;
    });

    const thumbs = state.collections[collectionId].thumbs?.filter((doc) => {
      const id = doc.documentId;
      return id !== documentId;
    });
    state.collections[collectionId] = {
      ...state.collections[collectionId],
      documents,
      thumbs,
      thumbUrl,
    };
  },
  [RemoveCollection](state, collectionId) {
    delete state.collections[collectionId];
  },

  [UpdateCollection](state, updatedCollection) {
    const { collectionId } = updatedCollection;
    // need documents such as update has no influence of documents in collection
    const documents = state.collections[collectionId].documents;
    state.collections[collectionId] = { ...state.collections[collectionId], ...updatedCollection, documents };
  },

  [SetCollectionThumbs](state, { collectionId, thumbs }) {
    // this is for collections overview modal, when we need the thumbs
    state.collections[collectionId] = { ...state.collections[collectionId], thumbs };
  },

  [SetCollection](state, collection) {
    //TODO favorites should  have 'favorites' key in store collection and org/favorites
    if (collection.collectionId.includes('favorites')) {
      state.collections[COLLECTIONS.favorites] = {
        ...state.collections[COLLECTIONS.favorites],
        ...collection,
        collectionId: COLLECTIONS.favorites,
      };
    } else {
      state.collections[collection.collectionId] = {
        documents: [],
        thumbs: [],
        thumbUrl: '',
        collectionName: '',
        collectionDescription: '',
        ...state.collections[collection.collectionId],
        ...collection,
      };
    }
  },
};

const actions = {
  [RemoveCollection]({ commit }, collectionId) {
    commit(RemoveCollection, collectionId);
  },
  [UpdateCollection]({ commit }, updatedCollection) {
    commit(UpdateCollection, updatedCollection);
  },
  [AddToCollection]: ({ commit }, data) => {
    commit(AddToCollection, data);
  },
  [RemoveFromCollection]: ({ commit }, data) => {
    commit(RemoveFromCollection, data);
  },
  [SetCollection]: ({ commit }, data) => {
    commit(SetCollection, data);
  },
  [CreateCollection]: ({ commit }, data) => {
    commit(CreateCollection, data);
  },
  [SetCollections]: ({ commit }, data) => {
    data.forEach((collection) => {
      commit(SetCollection, collection);
    });
  },
  [SetCollectionThumbs]: ({ commit }, data) => {
    commit(SetCollectionThumbs, data);
  },
};

export default {
  namespaced: true, // Important for namespacing module
  state,
  mutations,
  actions,
  getters,
};
